<template src="./Tremfya.html"> </template>

<script>
import ContentBase from './ContentBase.vue';
import { mapState } from 'vuex';
import { tremfya as menuItems } from '@/data/sections';
// import { debounce } from 'lodash';

export default {
  mixins: [ContentBase],
  data() {
    return {
      menuItems
    };
  },
  computed: {
    ...mapState(['userAgent'])
  },
  mounted() {}
};
</script>

<style scoped>
</style>
